import Api from '../api/api.js';


export default class Activities {


	init()
	{
		this.cacheDom();
		this.bindEvents();
		this.$form.trigger('change');
	}

	cacheDom()
	{
		this.$form     = $('#lesson-filters');
		this.$search   = $('#lesson-filters input[type=search]');
		this.$contents = $('.ajax-contents');
		this.$taglist  = $('.ajax-taglist');
	}

	bindEvents()
	{
		this.$form.on('change', this.onFilterChange.bind(this));

		this.$search.on('keyup', this.onFilterChange.bind(this));
	}

	loader()
	{
		return $.get('/loaders/square.html');
	}

	onFilterChange(e)
	{
		e.preventDefault();
		
		var params = this.$form.serializeObject();

		this.loader().then((loader) => {

			this.$contents.html(loader);
			this.$taglist.html(loader);
			this.getLessons(params).getTags(params);
		
		});
	}

	getLessons(params = {}) 
	{
		(new Api).getRequest('/activities/lessons', params)
		   .then((response) => {
				this.$contents.html(response.contents);
			});
		return this;
	}

	getTags(params = {})
	{
		(new Api).getRequest('/activities/tags', params)
		   .then((response) => {
				this.$taglist.html(response.taglist);
			});	
		return this;
	}

}